import { Component, OnInit } from '@angular/core';
import { FolderModel } from '../../models/folder-model';
import { FoldersService } from '../../services/folders.service';
import { combineLatest, debounce, debounceTime } from 'rxjs';

@Component({
  selector: 'app-folder-sub-list',
  templateUrl: './folder-sub-list.component.html',
  styleUrl: './folder-sub-list.component.css'
})
export class FolderSubListComponent implements OnInit {

  subFolders: FolderModel[] = [];
  collapsed = false;
  showSubs = false;

  constructor(private folderSvc: FoldersService) {
  }

  ngOnInit(): void {
    combineLatest([this.folderSvc.selectedFolder$, this.folderSvc.foldersLoaded$])
      .pipe(debounceTime(50))
      .subscribe(([selectedPath, loaded]) => {
        if (selectedPath && loaded) {
          let fldrs = this.folderSvc.getImmediateChildFolders();
          // console.log("getting Children: ", JSON.stringify(fldrs));
          if (this.subFolders.length > 0) {
            this.showSubs = true;
          }
          else {
            this.showSubs = false;
          }
          this.subFolders = fldrs;
        }
      });
  }

  onFolderClick(f: string) {
    this.folderSvc.setSelectedFolder(f);
  }
}
